import { createStore } from 'zustand-x';

export const goBackStore = createStore('goBack')(
  {
    canGoBack: false,
    isPopupOpen: false,
  },
  { devtools: { enabled: true } }
).extendActions((set) => ({
  goBack: () => {
    set.canGoBack(true);
  },
  dontGoBack: () => {
    set.canGoBack(false);
  },
  closePopup: () => {
    set.isPopupOpen(false);
  },
  openPopup: () => {
    set.isPopupOpen(true);
  },
}));
